<template lang="pug">
  .column.center
    img.m4-bottom-8(:src='imageToShow' :alt='$t("token.altImage")')
    h3.title-container.text-xbig.bold.m4-bottom-4.text-center {{ title }}
    span.message-container.text-normal.m4-bottom-9.text-center(v-if='message') {{ message }}
    p.message-container.text-normal.m4-bottom-9.text-center(v-else)
      | {{ $t('token.expiredTokenMessageStart') + ' ' }}
      span.text-normal.request(
        @click='renewInvitation'
        :class='{active: userId && schoolId}'
      ) {{ $t('token.expiredTokenMessageRequest') }}
      | {{ ' ' + $t('token.expiredTokenMessageEnd') }}
    a.text-normal.blue.bold(@click='showElement({ element: "contactModal" })') {{ $t('token.contact') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'

import usedToken from '@/assets/usedToken.svg'
import expiredToken from '@/assets/expiredToken.svg'
import { i18n } from '../main'

export default {
  data() {
    return {
      usedToken,
      expiredToken
    }
  },
  props: {
    title: { type: String, required: true },
    message: { type: String, required: false },
    expired: { type: Boolean, required: false },
    userId: { type: String },
    schoolId: { type: Number }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    }),
    imageToShow() {
      return this.expired ? this.expiredToken : this.usedToken
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'requestInvitationResend'
    ]),
    async renew() {
      this.hideElement({ element: 'choiceModal' })
      this.showElement({ element: 'fullPageLoader' })
      const { success } = await this.requestInvitationResend({
        userId: this.userId,
        schoolId: this.schoolId,
        locale: this.locale
      })
      this.hideElement({ element: 'fullPageLoader' })
      if (success) {
        this.showElement({
          element: 'successModal',
          props: { title: i18n.t('token.renewInvitationSuccessTitle') }
        })
      } else {
        this.$notify({
          group: 'custom-toast',
          text: i18n.t('token.requestInvitationResendError'),
          type: 'error'
        })
      }
    },
    async renewInvitation() {
      if (!this.userId || !this.schoolId) return
      this.showElement({
        element: 'choiceModal',
        props: {
          title: i18n.t('token.renewConfirmModal.title'),
          message: i18n.t('token.renewConfirmModal.message'),
          rightLabel: i18n.t('token.renewConfirmModal.rightLabel'),
          rightFunc: this.renew
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import 'src/scss/variables/colors';

.title-container {
  max-width: 312px;
}

.message-container {
  max-width: 580px;
}

.request {
  display: inline;
  &.active{
    color: $blue;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
